import { path } from 'ramda';
import { IEntity } from './interface';

export const getPricingDataFromEntity = (entity: IEntity) => {
  const isListing = entity.type === 'listing';
  const priceMaybe = isListing ? { price: path(['attributes', 'price'], entity) } : {};
  const paidExtrasData = path(['attributes', isListing ? 'publicData' : 'protectedData', 'paidExtrasData'], entity);
  const pricePerExtraGuest = path(['attributes', isListing ? 'publicData' : 'protectedData', 'pricePerExtraGuest'], entity);
  const pricingBaseNumberOfPeople = path(['attributes', isListing ? 'publicData' : 'protectedData', 'pricingBaseNumberOfPeople'], entity);

  return {
    ...priceMaybe,
    paidExtrasData,
    pricePerExtraGuest,
    pricingBaseNumberOfPeople,
  };
};

export const getGuestCountWeighted = (adultCount: number, childCount: number) => {
  if (!childCount) return adultCount;

  const childCountWeighted = childCount * 0.5;

  return adultCount + childCountWeighted;
}

export const isDynamicPrice = (minAmountPerHour: number, priceAmount: number, adultCount: number, childCount: number) => {
  if (!adultCount) return false;

  const guestCountWeighted = getGuestCountWeighted(adultCount, childCount);

  return minAmountPerHour > priceAmount && Math.round(minAmountPerHour / guestCountWeighted) > priceAmount;
};

export const getPriceAmountPerHour = (minAmountPerHour: number, priceAmount: number, adultCount: number, childCount: number) => {
  if (!isDynamicPrice(minAmountPerHour, priceAmount, adultCount, childCount)) return priceAmount;

  const guestCountWeighted = getGuestCountWeighted(adultCount, childCount);

  return Math.round(minAmountPerHour / guestCountWeighted);
};
